import HeroSection from './components/HeroSection';
import NewsSection from './components/NewsSection';
import GamesSection from './components/GamesSection';
import AboutSection from './components/AboutSection';
import FooterSection from './components/FooterSection';

export default function HomePage() {
  return (
    <main className="w-full">
      <HeroSection />
      <NewsSection />
      <GamesSection />
      <AboutSection />
      <FooterSection />
    </main>
  );
}
